import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { InputNumberModule } from "primeng/inputnumber";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { MessageModule } from "primeng/message";
import { MessagesModule } from "primeng/messages";
import { TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { ColorsComponent } from "./components/colors/colors.component";
import { InputTrimDirective } from "./directives/input-trim.directive";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { ToastModule } from "primeng/toast";
import { DateAgoPipe } from "./pipes/date-ago.pipe";
import { SanitizePipe } from "./pipes/sanitize.pipe";
import { TagModule } from "primeng/tag";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";

const MODULES = [
  ToastModule,
  FormsModule,
  ReactiveFormsModule,
  InputTextModule,
  ButtonModule,
  TableModule,
  DialogModule,
  InputNumberModule,
  MessageModule,
  MessagesModule,
  InputSwitchModule,
  ConfirmDialogModule,
  TooltipModule,
  TagModule,
  CalendarModule,
  DropdownModule,
];

@NgModule({
  declarations: [ColorsComponent, InputTrimDirective, TimeAgoPipe, DateAgoPipe, SanitizePipe],
  imports: [CommonModule, ...MODULES],
  exports: [...MODULES, ColorsComponent, InputTrimDirective, TimeAgoPipe, DateAgoPipe, SanitizePipe],
})
export class SharedModule {}
